module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('editable-grid-row', {
    class: {
      error: _vm.$v.$error
    },
    attrs: {
      "activeRow": _vm.activeRow
    }
  }, [_c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 0,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false,
      "has-danger": !_vm.$v.unique && _vm.$v.$error
    }
  }, [_c('span', {
    attrs: {
      "id": 'uuid' + _vm.promotion.uuid + '_' + _vm.itemIndex
    },
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm.item.plu) + "\n      ")]), _vm._v(" "), (!_vm.$v.unique && _vm.$v.$error) ? _c('b-tooltip', {
    attrs: {
      "target": 'uuid' + _vm.promotion.uuid + '_' + _vm.itemIndex,
      "placement": "right"
    }
  }, [_vm._v("\n        Some of the products already have an overlapping discount or promotion set in following events:\n        "), _c('strong', [_vm._v(_vm._s(_vm.$v.$params.unique.matches(_vm.promotion)))]), _vm._v("."), _c('br'), _c('br'), _vm._v("\n        Try selecting different products, changing customer group or picking different date range.\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 1,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm._f("fixedLength")(_vm.item.name, 20)) + "\n      ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 2,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm._f("fixedLength")(_vm.typeName, 30)) + "\n      ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 3,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm.customerGroupName) + "\n      ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 4,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": _vm.promotion.isCustomDate,
      "has-danger": _vm.$v.startDate.$error
    }
  }, [_c('span', {
    slot: "edit"
  }, [_c('flatpickr', {
    attrs: {
      "config": Object.assign({}, _vm.fpOptions, {
        altInputClass: 'form-control startDate'
      })
    },
    on: {
      "input": function($event) {
        _vm.$v.startDate.$touch()
      }
    },
    model: {
      value: (_vm.promotion.startDate),
      callback: function($$v) {
        _vm.promotion.startDate = $$v
      },
      expression: "promotion.startDate"
    }
  })], 1), _vm._v(" "), (_vm.showDates) ? _c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm._f("formatDate")(_vm.promotion.startDate)) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 5,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": _vm.promotion.isCustomDate,
      "has-danger": _vm.$v.endDate.$error
    }
  }, [_c('span', {
    slot: "edit"
  }, [_c('flatpickr', {
    attrs: {
      "config": Object.assign({}, _vm.fpOptions, {
        altInputClass: 'form-control endDate'
      })
    },
    on: {
      "input": function($event) {
        _vm.$v.endDate.$touch()
      }
    },
    model: {
      value: (_vm.promotion.endDate),
      callback: function($$v) {
        _vm.promotion.endDate = $$v
      },
      expression: "promotion.endDate"
    }
  })], 1), _vm._v(" "), (_vm.showDates) ? _c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm._f("formatDate")(_vm.promotion.endDate)) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 6,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm.promotion.page) + "\n      ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 7,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm.promotion.positionOnPage) + "\n      ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 8,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm.basePrice) + "\n      ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 9,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm.item.cost) + "\n      ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 10,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm._f("rounded")(_vm.discountedPrice)) + "\n      ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 11,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm._f("rounded")(_vm.margin)) + "%\n      ")])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 12,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n        " + _vm._s(_vm.promotion.targetMargin)), (_vm.promotion.targetMargin || _vm.promotion.targetMargin === 0) ? _c('span', [_vm._v("%")]) : _c('span', [_vm._v("-")])])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "column": 13,
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [(_vm.promotion.rewards.rewardMoneyEarnedPerItem !== null && _vm.promotion.type.includes('SPEND_GET')) ? _c('span', [_vm._v(_vm._s(_vm.promotion.rewards.rewardMoneyEarnedPerItem))]) : (_vm.promotion.rewards.rewardMoneyEarnedPerRedemption !== null && _vm.promotion.type.includes('BUY_ITEMS_GET')) ? _c('span', [_vm._v(_vm._s(_vm.promotion.rewards.rewardMoneyEarnedPerRedemption))]) : _c('span', [_vm._v("-")])])]), _vm._v(" "), _c('editable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "hidden": "true",
      "active-row": _vm.activeRow,
      "active-column": _vm.activeColumn,
      "is-being-edited": _vm.isBeingEdited,
      "is-editable": false
    }
  }, [_c('span', {
    slot: "view"
  }, [_vm._v("\n\t\t  " + _vm._s(_vm.promotion.subsidyPercentageOfDiscount) + "\n      ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-7de648ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CopyEvent/SpecialPromotionItem.vue
// module id = 1697
// module chunks = 1